module.exports = __webpack_public_path__ + "img/IDEX_80X30.b8600808.png";